import React from 'react';
import { block } from '../../utils/cn';
import { eventBroker } from '../../utils/event-broker';
import { DragHandleIcon } from './DragHandleIcon';
const b = block('list');
const defaultRenderItem = (item) => String(item);
export class ListItem extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.getRef = () => this.ref;
        this.onClick = (event) => {
            var _a, _b;
            ListItem.publishEvent({
                domEvent: event,
                eventId: 'click',
            });
            (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.item, this.props.itemIndex);
        };
        this.onMouseEnter = () => this.props.onActivate(this.props.itemIndex);
        this.onMouseLeave = () => this.props.onActivate(undefined);
    }
    render() {
        const { item, style, sortable, sortHandleAlign, itemClassName, selected, active } = this.props;
        return (React.createElement("div", { className: b('item', {
                sortable,
                active,
                selected,
                inactive: item.disabled,
                'sort-handle-align': sortHandleAlign,
            }, itemClassName), style: style, onClick: this.onClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, ref: this.ref },
            this.renderSortIcon(),
            this.renderContent()));
    }
    renderSortIcon() {
        const { sortable } = this.props;
        return sortable ? (React.createElement("div", { className: b('item-sort-icon') },
            React.createElement(DragHandleIcon, null))) : null;
    }
    renderContent() {
        const { renderItem = defaultRenderItem, item, active, itemIndex } = this.props;
        return React.createElement("div", { className: b('item-content') }, renderItem(item, active, itemIndex));
    }
}
ListItem.publishEvent = eventBroker.withEventPublisher('List');
